export function isNumberInRange(num, values) {
    const lowerBound = Math.min(...values);
    const upperBound = Math.max(...values);
    return !(num < lowerBound || num > upperBound);
}
export function getIteratorObject(max, min, fixedSizeSegmentsSteps, customIterator) {
    return customIterator?.map((value, index) => {
        let percentage;
        if (fixedSizeSegmentsSteps) {
            percentage = Math.ceil((100 / (customIterator.length - 1)) * index); // fixed size percentage
        }
        else {
            percentage = ((value - min) / (max - min)) * 100; // linear proportion percentage
        }
        return {
            value,
            key: index,
            percentage,
        };
    });
}
export function toHHMM(amountInSeconds) {
    return new Date(amountInSeconds * 1000).toISOString().slice(11, 16);
}
export function timeToSeconds(time) {
    const [hours, minutes] = time.split(":").map(Number);
    return hours * 3600 + minutes * 60;
}
